"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {},
    title: {
        marginBottom: 7
    },
    description: {
        marginBottom: 7
    },
    items: {
        listStyle: 'none',
        paddingLeft: 0,
        margin: 0,
        '&:not(:first-child)': {
            borderWidth: `1px 0 0 0`,
            borderStyle: `solid`,
            borderColor: theme.grey6
        },
        '&:not(:last-child)': {
            marginBottom: 7
        }
    }
});
//# sourceMappingURL=collection.style.js.map